import * as NexusStream from "./stream";
import environment from '@/config';
import storage from "@/storage";
import { BaseMonitorWs } from "./ws.base";
import {Container, Service} from "typedi";

@Service("CloudMonitorWs")
class CloudMonitorWs extends BaseMonitorWs {

    async connect() {
        const host: string = environment.rtc.host;
        const site = await storage.get<any>(storage.SITE);
        const queryParameters = `hash=${site.hash}`;
        const transports = ['websocket'];
        const debug = false;
        this.stream = await NexusStream.connect({ host, queryParameters, transports, debug });
    }
}

const service: CloudMonitorWs = Container.get("CloudMonitorWs");
export default service;
